import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetUserDetailApi } from '../redux/actions/teams/members/GetUserDetailsActions';

const UsersDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const userData = location.state || {};
  const [details, setDetails] = useState(userData);

  const { response: usersDetailsResponse, loading, error } = useSelector(
    (state) => state.UsersDetails
  );

  useEffect(() => {
    if (id) {
      dispatch(GetUserDetailApi(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (usersDetailsResponse?.status && usersDetailsResponse.data) {
      setDetails(usersDetailsResponse.data);
    }
  }, [usersDetailsResponse]);

  if (loading)
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: 'black' }}>
        Loading...
      </div>
    );
  if (error)
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: 'black' }}>
        Error loading promotion details: {error?.data || 'Unknown error'}
      </div>
    );

  return (
    <>
        <div className="content-wrapper" style={{ backgroundColor: '#f5f5f5', minHeight: '100vh'}}>
      <section className="main-section">
        <div className="container">
          <div className="row">
            <div className='col-12'>
                <div
                style={{
                    padding: '20px',
                    fontFamily: 'Arial, sans-serif',
                    backgroundColor: '#fff',
                    color: '#666',
                    borderRadius: '8px',                
                    textAlign: 'center',
                    width: '100%', 
                    maxWidth: '100%',
                }}
                >
                <div style={{ marginBottom: '20px' }}>
                    <img
                    src={`${
                        details?.profilePic ||
                        `${process.env.REACT_APP_BACKEND_PRODUCTION_URL}/uploads/20250912T082219636Z821019_marathonmindset.png`
                    }`}
                    alt="User"
                    style={{ maxWidth: '200px', height: 'auto', display: 'inline-block' }} // Increased maxWidth
                    />
                </div>
                
                </div>
            </div>
            
          </div>
          <div
                style={{
                  padding: '20px',                  
                  backgroundColor: '#fff',
                  borderRadius: '4px',
                  width: '100%', 
                }}
              >
                <div className='row g-3 mt-4'>
                <div className='col-12 col-sm-6 col-md-4'>
                    <h3 style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 5px', color: '#666' }}>Name</h3>
                    <p style={{ margin: '0', color: '#333' }}>{details?.name || 'N/A'}</p>
                </div>
                <div className='col-12 col-sm-6 col-md-4'>
                    <h3 style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 5px', color: '#666' }}>Email Address</h3>
                    <p style={{ margin: '0', color: '#333' }}>{details?.email || 'N/A'}</p>
                </div>
                <div className='col-12 col-sm-6 col-md-4'>
                    <h3 style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 5px', color: '#666' }}>Due Date</h3>
                    <p style={{ margin: '0', color: '#333' }}>
                    {details?.due_date ? details.due_date.split('T')[0] : 'N/A'}
                    </p>
                </div>
                <div className='col-12 col-sm-6 col-md-4'>
                    <h3 style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 5px', color: '#666' }}>Current Subscription</h3>
                    <p style={{ margin: '0', color: '#333' }}>{details?.current_subscription || 'N/A'}</p>
                </div>
                <div className='col-12 col-sm-6 col-md-4'>
                    <h3 style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 5px', color: '#666' }}>Quizzes completed:</h3>
                    <p style={{ margin: '0', color: '#333' }}>{details?.quiz_completed || 'N/A'}</p>
                </div>
            </div>
              </div>
          
        </div>
      </section>
    </div>
    </>
  );
};

export default UsersDetails;